import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedStatusView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'status'
  humanize: true
  alias: 'Moderation Result'

  initialize: (@options = {}) ->
    super(@options)
    @unmodifiableByModerators = !($('li.active a span #name').text() == 'My History')

  removeFilter: (value) ->
    @searchQuery.removeStatus(value)
